import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useGetDagStatus } from '../../../../../api/dags'

dayjs.extend(relativeTime)

const POLL_INTERVAL = 60_000

const STATUS_CONFIG = {
  never_run: { label: 'Never run', color: '#9E9E9E', bg: '#F5F5F5' },
  running: { label: 'Running', color: '#1565C0', bg: '#E3F2FD' },
  success: { label: 'Success', color: '#2E7D32', bg: '#E8F5E9' },
  failed: { label: 'Failed', color: '#C62828', bg: '#FFEBEE' }
}

const useStyles = makeStyles({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 11,
    fontWeight: 600,
    borderRadius: 4,
    padding: '2px 8px',
    lineHeight: '16px'
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%'
  },
  when: {
    fontWeight: 400,
    opacity: 0.8
  }
})

function WorkflowStatus ({ dagId }) {
  const classes = useStyles()

  const { data: dagStatus } = useGetDagStatus(dagId, {
    refetchInterval: POLL_INTERVAL
  })

  if (!dagStatus) return null

  const config = STATUS_CONFIG[dagStatus.status] ?? STATUS_CONFIG.never_run
  const timeLabel = dagStatus.when ? dayjs(dagStatus.when).fromNow() : null

  return (
    <span
      className={classes.badge}
      style={{ color: config.color, backgroundColor: config.bg }}
    >
      <span className={classes.dot} style={{ backgroundColor: config.color }} />
      {config.label}
      {timeLabel ? <span className={classes.when}>{timeLabel}</span> : null}
    </span>
  )
}

WorkflowStatus.propTypes = {
  dagId: PropTypes.string.isRequired
}

export default WorkflowStatus
